import styled from "styled-components";

export const QuestionnaireCardContainer = styled.div<{
  $questionnaireStarred?: boolean;
}>`
  ${(props) =>
    props.$questionnaireStarred &&
    "background-color: var(--ons-color-ocean-blue-tint); padding-left: 18px; padding-right: 18px;"};
  border-bottom: 1px solid var(--ons-color-grey-75);
  margin: 0px;
  padding-top: 18px;
  padding-bottom: 9px;
`;

export const QuestionnaireCardTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const QuestionnaireCardTitleButton = styled.button`
  color: var(--ons-color-text-link);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-position: under;
  cursor: pointer;
  font-size: 1.2222222222rem;
  background-color: transparent;
  border: 0;
  margin: 0 0 1rem;
  padding: 0;
  text-align: left;
  &:hover {
    color: var(--ons-color-text-link-hover);
    text-decoration: underline solid var(--ons-color-text-link-hover) 2px;
  }
  &:focus {
    background-color: var(--ons-color-focus);
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
    box-shadow:
      0 -2px var(--ons-color-focus),
      0 4px var(--ons-color-text-link-focus);
    color: var(--ons-color-text-link-focus);
    outline: 3px solid transparent;
    outline-offset: 1px;
    text-decoration: none;
  }
`;

export const QuestionnaireCardDateContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  p {
    white-space: nowrap;
  }
`;

export const Icon = styled.span`
  line-height: 1rem;
  display: inline-block;
  text-align: center;
  padding-left: 9px;
`;
